import { RequestThrottledFrame, GetScrollPercent, CompareAgainstThreshold } from "../tfs-utilities";
import Analytics from "../analytics";

const DailyDose = {
  data: {
    dailyDoseSelector: ".js-daily-dose",
    gtmScrollThresholds: [10, 25, 50, 75, 90],
    gtmEvent: "scroll-daily-dose",
    gtmAction: "scroll on daily dose"
  },

  init() {
    DailyDose.trackScrollForGTM();
  },

  sendGTMEvent(action, label) {
    Analytics.track(DailyDose.data.gtmEvent, {
      action,
      label
    });
  },

  trackScrollForGTM() {
    let lastThreshold = 0;

    RequestThrottledFrame("scroll", "optimizedScroll--GTM");
    window.addEventListener(
      "optimizedScroll--GTM",
      () => {
        const percent = GetScrollPercent(DailyDose.data.gtmScrollThresholds);
        const currentThreshold = CompareAgainstThreshold(percent, DailyDose.data.gtmScrollThresholds);

        if (currentThreshold > lastThreshold) {
          DailyDose.sendGTMEvent(DailyDose.data.gtmAction, currentThreshold);
        }

        lastThreshold = currentThreshold;
      },
      false
    );
  }
};
export default DailyDose;
